import {
    Row,
    Col,
    Typography,
    Table,
    Button,
    message,
  } from "antd";
  import { routes } from "common/routes";
  import { generateHeaders } from "common/utils";
  import { AppPageHeader } from "components/AppPageHeader";
  import { useAppDispatch } from "hooks/useAppDispatch";
  import { useAppSelector } from "hooks/useAppSelector";
  import { useDocumentTitle } from "hooks/usePageTitle";
  import { useEffect, useMemo } from "react";
  import { useNavigate } from "react-router-dom";
import { cancelPricingOverride, removeProcessingPricingOverride, savePricingOverride } from "store/franchise/franchiseSlice";
  
  const MESSAGE_KEY = "SAVE_PRICING_OVERRIDE";
  
  export const PricingOverrideSavePage = () => {
    useDocumentTitle("Save Pricing Override");
    const { processingPricingOverride, status, error } = useAppSelector(
      (state) => state.franchiseServices
    );
    const dispatch = useAppDispatch();
    const navigate = useNavigate();

    // useEffect(() => {
    //     if (
    //         processingFranchiseMapping &&
    //         processingFranchiseMapping.key
    //     ) {
    //       navigate(`/${routes.PPD.SAVE}`, {});
    //     }
    
    //     return () => {
    //       message.destroy();
    //     };
    //   }, [processingFranchiseMapping, navigate]);
  
    useEffect(() => {
      const { timeUploaded } = processingPricingOverride;
      if (timeUploaded) {
        const uploadedTime = new Date(timeUploaded).getTime();
        const currentTime = new Date().getTime();
        const minsPassed = (currentTime - uploadedTime) / 1000 / 60;
  
        if (minsPassed >= 15) {
          dispatch(removeProcessingPricingOverride());
        }
      }
  
      if (!Object.keys(processingPricingOverride).length) { 
        navigate(`/${routes.FRANCHISE.UPLOAD_PRICING_OVERRIDE}`);
      }
    }, [dispatch, processingPricingOverride, navigate]);

    useEffect(() => {
      if (status === "loading") {
        message.loading({ content: "saving upload", key: MESSAGE_KEY });
      } else if (status === "success") {
        message.success({
          content: "Pricing Override saved!",
          duration: 5,
          key: MESSAGE_KEY,
        });
      } else if (status === "cancelling") {
        message.loading({ content: "Cancelling upload", key: MESSAGE_KEY });
      } else if (status === "error") {
        message.error({ content: error, key: MESSAGE_KEY });
      }
  
      return () => {
        message.destroy();
      };
    }, [status, error]);
  
    let content;
    const { headerMapping } = processingPricingOverride;
    const { Text } = Typography;
  
    const generateMemoizedHeaders = useMemo(
      () => generateHeaders(headerMapping),
      [headerMapping]
    );
  
    const onSaveRequisition = () => {
      dispatch(savePricingOverride());
    };
  
    const onCancelSave = () => {
      dispatch(cancelPricingOverride());
    };
  
    if ((processingPricingOverride.success) === 0) {
      content = <Text>Nothing to show here!</Text>;
    } else {
      const headers = generateMemoizedHeaders || {};
      const successRows = processingPricingOverride.successRows;
      const data = successRows?.map((row, i) => ({ ...row, key: `data-${i}` }));
      const columns = [
        ...Object.keys(headers).map(
          (key) =>
            ({
              key,
              title: headers[key],
              dataIndex: key,
            } as any)
        ),
      ];
      content = (
        <Table
          size="small"
          columns={columns}
          dataSource={data}
          scroll={{ y: 500, x: "100vh" }}
          summary={() => (
            <Table.Summary fixed="bottom">
              <Table.Summary.Row>
                <Table.Summary.Cell index={0} colSpan={24}>
                  <Row>
                    <Col>
                      <Button
                        type="primary"
                        onClick={onSaveRequisition}
                        loading={status === "loading"}
                        disabled={status === "loading"}
                      >
                        Save Pricing Override
                      </Button>
                    </Col>
                    <Col style={{ justifyContent: "left", marginLeft: "20px" }}>
                      <Button
                        onClick={onCancelSave}
                        disabled={status === "loading"}
                      >
                        Cancel
                      </Button>
                    </Col>
                  </Row>
                </Table.Summary.Cell>
              </Table.Summary.Row>
            </Table.Summary>
          )}
        ></Table>
      );
    }
  
    return (
      <>
        <Row>
          <Col>
            <AppPageHeader title="Save Pricing Override" />
          </Col>
        </Row>
        <Row>
          <Col xs={24}>{content}</Col>
        </Row>
      </>
    );
  };
  